import {FC} from 'react';
import {Box} from '@chakra-ui/react';
import {api, IDocumentInfo, IDocumentQueueItem} from '@kcast-fe/core';
import {TBreakpointStyle} from 'ui-kit';
import {docsUtils} from 'core';

import {DocumentListItem} from './components';

interface IProps {
  query: string;
  queue: Array<IDocumentQueueItem>;
  documentsQueue: Array<IDocumentInfo>;
  gridTemplate: TBreakpointStyle;
}

const DocumentListFC: FC<IProps> = ({query, queue, documentsQueue, gridTemplate}) => {
  const {data: documents} = api.documents.useDocumentsQuery();

  const filteredDocuments = query
    ? (documents?.docs.filter((d) => d.title.toLowerCase().includes(query.toLowerCase())) ?? [])
    : (documents?.docs ?? []);

  return (
    <Box>
      {[...documentsQueue, ...filteredDocuments].map((item) => {
        const queueItem = queue.find((q) => q.id === item.id);
        const progress = queueItem?.progress ?? 0;

        const isUploading = documentsQueue.some((q) => q.id === item.id) && progress !== 1;
        const isProcessing = !queueItem?.isDone && progress === 1;

        return (
          <DocumentListItem
            item={item}
            key={item.id}
            progress={progress}
            icon={docsUtils.getSvgIconByExtension(item.title)}
            isUploading={isUploading}
            isProcessing={isProcessing}
            gridTemplate={gridTemplate}
          />
        );
      })}
    </Box>
  );
};

export const DocumentList = DocumentListFC;
